// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3nq-8","requiredAsterisk":"Info_requiredAsterisk__9k1uU"};